import {
  NetworkCoverageMapDataContext
} from "@app/projects/network-assessment/maps/network-coverage-map/contexts/NetworkCoverageMapDataContext";
import {
  ProviderAccordionSelectedTab,
  ProviderFetchMessageStatus
} from "@app/projects/network-assessment/maps/network-coverage-map/enumerators";
import { ProviderFetchMessageData } from "@app/projects/network-assessment/maps/network-coverage-map/interfaces";
import { ProviderNetworkTypeEnum } from "@app/shared/enums/providerNetworkTypeEnum";
import { QESAlert } from "@app/shared/qes-standards/Alert";
import { JSX, useContext } from "react";

const ProviderFetchMessage = (): JSX.Element => {

  const mapDataContext = useContext(NetworkCoverageMapDataContext);

  const prepareProvidersForError = (providerFetchMessageData: ProviderFetchMessageData[]): string => {
    return providerFetchMessageData
      .filter(provider => provider.providerFetchMessageStatus == ProviderFetchMessageStatus.Error)
      .map(provider => provider.providerNetworkType.toString())
      .sort()
      .join(" & ");
  }

  const getMessage = (): JSX.Element => {
    if (mapDataContext.loadingProviders) {
      return <></>;
    }

    const isNetworkTabSelected = mapDataContext.providerAccordionSelectedTab === ProviderAccordionSelectedTab.NetworkProviders;

    const messages = mapDataContext.providerFetchMessages.filter(
      message => ((message.providerNetworkType === ProviderNetworkTypeEnum.Network) && isNetworkTabSelected) ||
        ((message.providerNetworkType === ProviderNetworkTypeEnum.Market || message.providerNetworkType === ProviderNetworkTypeEnum.Prospect) && !isNetworkTabSelected));

    const errorMessages = messages.filter(message => message.providerFetchMessageStatus === ProviderFetchMessageStatus.Error);
    if (errorMessages.length > 0) {
      return <QESAlert classNames="network-coverage-map__provider-fetch-message-banner" type={"danger"} persist={true}>There was an error loading {prepareProvidersForError(errorMessages)} providers</QESAlert>
    }

    const networkProvidersUnavailable =
      !!isNetworkTabSelected &&
      !!messages.filter(message => message.providerNetworkType === ProviderNetworkTypeEnum.Network)
        .find(message => message.providerFetchMessageStatus === ProviderFetchMessageStatus.Unavailable);

    const impactProvidersUnavailable =
      !isNetworkTabSelected &&
      !!messages.filter(message => message.providerNetworkType !== ProviderNetworkTypeEnum.Network)
        .find(message => message.providerFetchMessageStatus === ProviderFetchMessageStatus.Unavailable) &&
      mapDataContext.impactProviderCount === 0;

    if (!!networkProvidersUnavailable || !!impactProvidersUnavailable) {
      return <p>There are no providers available for the selected county-specialty group combination</p>;
    }

    if ((isNetworkTabSelected && mapDataContext.visibleAccordionProviders.filter(p => p.providerNetworkType === ProviderNetworkTypeEnum.Network).length === 0) ||
      (!isNetworkTabSelected && mapDataContext.visibleAccordionProviders.filter(p => p.providerNetworkType !== ProviderNetworkTypeEnum.Network).length === 0)
    ) {
      return <p>There are more providers available. Consider adjusting your filters or recentering the map to view additional provider options</p>;
    }

    return <></>;
  }

  return (
    getMessage()
  );
}

export { ProviderFetchMessage }